import React from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import CustomToolbar from '../common/datagrid/CustomToolbar';
import CustomLoadingOverlay from '../common/datagrid/CustomLoadingOverlay';

const ProductList = ({
  apiRef,
  columns,
  products,
  error,
  loading,
  handleRowEditStart,
  handleRowEditStop,
  handleCellFocusOut,
  handleRowClick,
}) => {
  const [pageSize, setPageSize] = React.useState(20);
  return (
    <div style={{ display: 'flex', height: 'calc(100vh - 240px)' }}>
      <div style={{ flexGrow: 1 }}>
        <DataGridPro
          apiRef={apiRef}
          rows={products ? products : []}
          columns={columns}
          components={{
            Toolbar: CustomToolbar,
            LoadingOverlay: CustomLoadingOverlay,
          }}
          componentsProps={{
            toolbar: { fileName: '제품리스트' },
          }}
          loading={loading}
          editMode="row"
          onRowClick={handleRowClick}
          onRowEditStart={handleRowEditStart}
          onRowEditStop={handleRowEditStop}
          onCellFocusOut={handleCellFocusOut}
          initialState={{ pinnedColumns: { right: ['actions'] } }}
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[5, 10, 20, 50, 100]}
          pagination
        />
      </div>
    </div>
  );
};

export default ProductList;
